import { useEffect, useState } from 'react'
import { searchBillTos } from '../api'
import { BillTo } from '../typings'
import { ISearchInput, ISearchResponse } from '@sales-center/common'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'

type State = ISearchResponse<BillTo> & {
  loading: boolean
}

const initialState: State = {
  count: 0,
  items: [],
  skip: 0,
  take: 0,
  loading: false,
}

export function useFetchBillTos(searchInput: ISearchInput) {
  const dispatch = useAppDispatch()

  const [state, setState] = useState(initialState)

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        setState((state) => ({ ...state, items: [], loading: true }))

        const result = await dispatch(searchBillTos(searchInput))

        if (mounted) {
          if (searchBillTos.fulfilled.match(result)) {
            setState({ ...result.payload, loading: false })
          } else {
            setState(initialState)
          }
        }
      } catch {
        if (mounted) setState(initialState)
      }
    }

    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, searchInput])

  return state
}
